export enum Type {
  wakeUp = 'wakeup',
  standby = 'standby',
  reboot = 'reboot',
  sendMessage = 'message',
  updateCertificates = 'update_certificates',
  updateLicenses = 'update_licenses',
  factoryDefaults = 'factory_defaults',
  configurationDefaults = 'configuration_defaults',
  screenDefaults = 'screen_defaults',
  reRegister = 're_register',
  moveToGroup = 'move_to_group',
  shutdown = 'shutdown',
}
